const setGeneralBucket = (userObj) => {
    return {
        type: "SET_GENERAL_DATA",
        payload: userObj
    }
}

export default {
    setGeneralBucket
}